import { render } from "./AppointmentsView.vue?vue&type=template&id=202009fa"
import script from "./AppointmentsView.vue?vue&type=script&lang=js"
export * from "./AppointmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__